module.exports = __webpack_public_path__ + "img/header-engagementRingsPlatinum.617aad7.webp";